// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ib-0";
export var actionModalContentContainer = "_ib-1";